import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WidgetListModalComponent} from './widgets/widget-list-modal/widget-list-modal.component';
import {ImageWidgetModalComponent} from './widgets/image-widget-modal/image-widget-modal.component';
import {YoutubeWidgetModalComponent} from './widgets/youtube-widget-modal/youtube-widget-modal.component';
import {SoundcloudWidgetModalComponent} from './widgets/soundcloud-widget-modal/soundcloud-widget-modal.component';
import {VimeoWidgetModalComponent} from './widgets/vimeo-widget-modal/vimeo-widget-modal.component';
import {SpotifyWidgetModalComponent} from './widgets/spotify-widget-modal/spotify-widget-modal.component';
import {TwitchWidgetModalComponent} from './widgets/twitch-widget-modal/twitch-widget-modal.component';
import {TiktokWidgetModalComponent} from './widgets/tiktok-widget-modal/tiktok-widget-modal.component';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {FormatPipesModule} from '@common/core/ui/format-pipes/format-pipes.module';
import {TranslationsModule} from '@common/core/translations/translations.module';
import {NoResultsMessageModule} from '@common/core/ui/no-results-message/no-results-message.module';
import {SkeletonModule} from '@common/core/ui/skeleton/skeleton.module';
import {LinkPreviewModule} from '../../../shared/link-preview/link-preview.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import {UploadImageControlModule} from '@common/shared/form-controls/upload-image-control/upload-image-control.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {TextWidgetModalComponent} from './widgets/text-widget-modal/text-widget-modal.component';
import {SocialsWidgetModalComponent} from './widgets/socials-widget-modal/socials-widget-modal.component';
import {MatTabsModule} from '@angular/material/tabs';
import {MatRippleModule} from '@angular/material/core';
import {BiolinkEditorComponent} from './biolink-editor.component';
import {BiolinkEditorButtonsComponent} from './biolink-appearance/biolink-editor-buttons/biolink-editor-buttons.component';
import {ColorPickerInputModule} from '@common/core/ui/color-picker/color-picker-input/color-picker-input.module';
import {BiolinkEditorFontsComponent} from './biolink-appearance/biolink-editor-fonts/biolink-editor-fonts.component';
import {GoogleFontSelectorModule} from '@common/shared/form-controls/google-font-selector/google-font-selector.module';
import {BiolinkAppearanceComponent} from './biolink-appearance/biolink-appearance.component';
import {BackgroundSelectorModule} from '@common/shared/form-controls/background-selector/background-selector.module';
import {BiolinkSettingsComponent} from './biolink-settings/biolink-settings.component';
import {LinkOptionsFormModule} from '../../link/link-options-form/link-options-form.module';
import {SlugControlModule} from '@common/shared/form-controls/slug-control/slug-control.module';
import {BiolinkEditorContentComponent} from './biolink-editor-content/biolink-editor-content.component';
import {SharedModule} from '../../../shared/shared.module';
import {RouterModule} from '@angular/router';
import {AnimationSelectorComponent} from './biolink-editor-content/biolink-editor-link/animation-selector/animation-selector.component';
import {BiolinkSlideoutPanelComponent} from './biolink-editor-content/biolink-slideout-panel/biolink-slideout-panel.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {BiolinkEditorLinkComponent} from './biolink-editor-content/biolink-editor-link/biolink-editor-link.component';
import {BiolinkEditorWidgetComponent} from './biolink-editor-content/biolink-editor-widget/biolink-editor-widget.component';
import {LeapLinkPanelComponent} from './biolink-editor-content/biolink-editor-link/leap-link-panel/leap-link-panel.component';
import {DatetimeInputModule} from '@common/core/ui/datetime-input/datetime-input.module';
import {ImageOrIconModule} from '@common/core/ui/image-or-icon/image-or-icon.module';
import { LinkThumbnailPanelComponent } from './biolink-editor-content/biolink-editor-link/link-thumbnail-panel/link-thumbnail-panel.component';

@NgModule({
    declarations: [
        BiolinkEditorComponent,
        WidgetListModalComponent,
        ImageWidgetModalComponent,
        YoutubeWidgetModalComponent,
        SoundcloudWidgetModalComponent,
        VimeoWidgetModalComponent,
        SpotifyWidgetModalComponent,
        TwitchWidgetModalComponent,
        TiktokWidgetModalComponent,
        TextWidgetModalComponent,
        SocialsWidgetModalComponent,
        BiolinkAppearanceComponent,
        BiolinkEditorButtonsComponent,
        BiolinkEditorFontsComponent,
        BiolinkSettingsComponent,
        BiolinkEditorContentComponent,
        AnimationSelectorComponent,
        BiolinkSlideoutPanelComponent,
        BiolinkEditorLinkComponent,
        BiolinkEditorWidgetComponent,
        LeapLinkPanelComponent,
        LinkThumbnailPanelComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        FormatPipesModule,
        TranslationsModule,
        NoResultsMessageModule,
        SkeletonModule,
        LinkPreviewModule,
        UploadImageControlModule,
        ColorPickerInputModule,
        GoogleFontSelectorModule,
        BackgroundSelectorModule,
        LinkOptionsFormModule,
        SlugControlModule,
        SharedModule,
        DatetimeInputModule,
        ImageOrIconModule,

        // material
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatDialogModule,
        DragDropModule,
        MatTabsModule,
        MatRippleModule,
        MatSlideToggleModule,
    ],
})
export class BiolinkEditorModule {}
